import api from './api';

export const workpapersAPI = {
  templates: () => api.get('/api/workpaper-templates'),
  list: (params) => api.get('/api/workpapers', { params }),
  create: (data) => api.post('/api/workpapers', data),
  get: (id) => api.get(`/api/workpapers/${id}`),
  update: (id, data) => api.patch(`/api/workpapers/${id}`, data),
  signoff: (id, role) => api.post(`/api/workpapers/${id}/signoff`, { role }),
  delete: (id) => api.delete(`/api/workpapers/${id}`),
};

export const WORKPAPER_STATUS_LABELS = {
  draft: 'Draft',
  in_progress: 'In Progress',
  reviewer_signoff: 'Reviewer Signed',
  partner_signoff: 'Partner Signed',
  completed: 'Completed',
};

export const WORKPAPER_STATUS_COLORS = {
  draft: 'bg-muted text-foreground/90 border-border',
  in_progress: 'bg-blue-100 text-blue-700 border-blue-200',
  reviewer_signoff: 'bg-indigo-100 text-indigo-700 border-indigo-200',
  partner_signoff: 'bg-purple-100 text-purple-700 border-purple-200',
  completed: 'bg-green-100 text-green-700 border-green-200',
};
